var RiskAssessment = {

    init: function () {
        RiskAssessment.bindPupilSearch();
        //RiskAssessment.bindSubmit();
    },

    bindPupilSearch: function() {
        $('#risk-assessments-pupil-search').select2({
            ajax: {
                url: '/admin/pupils/ajax',
                placeholder: 'Search by Pupil Name',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        page: params.page
                    };
                },
                results: function (data, page) {
                    return { results: data.results };
                },
            },
            minimumInputLength: 3
        }).on('select2:select', function(e) {
            window.location.href = '/risk-assessments?pupil=' + $(this).select2('data')[0].id;
        });
    },

    /* Key Skills piggy backs on IEP submit validation
    bindSubmit: function() {
        $('#risk-assessments-submit').click(function(e) {
            var select = $('#risk-assessments-pupil');
            if (select.val() === undefined || select.val() == '' || select.val() == null) {
                e.preventDefault();
                alert('Please select a pupil before continuing.');
            }
        });
    },
    */

    bindSubmit: function() {
        $('#risk-assessments-submit').click(function(e) {
            var stop = false;
            $('.risk-assessments-name').each(function(index) {
                //if ($(this).is(':empty')) {
                if ($(this).val() == '') {
                    stop = true;
                    alert('Please name all tasks before continuing.');
                }
            });
            if (stop) {
                e.preventDefault();
            }
        });
    },

};

